// src/Components/Loader.js
import React, { useState, useEffect } from 'react';

const LogoSVG = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#38bdf8" />
        <stop offset="100%" stopColor="#818cf8" />
      </linearGradient>
    </defs>
    
    <circle cx="50" cy="50" r="46" fill="none" stroke="#38bdf8" strokeWidth="1" opacity="0.2"/>
    <circle cx="50" cy="50" r="43" fill="none" stroke="#38bdf8" strokeWidth="2" opacity="0.4"/>
    <circle cx="50" cy="50" r="38" fill="none" stroke="#38bdf8" strokeWidth="3"/>
    <circle cx="50" cy="50" r="32" fill="none" stroke="#818cf8" strokeWidth="2" strokeDasharray="4,4" opacity="0.7"/>
    <circle cx="50" cy="50" r="28" fill="#0f172a"/>
    
    <text x="50" y="42" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="#38bdf8" textAnchor="middle">WW</text>
    <text x="50" y="58" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="#818cf8" textAnchor="middle">MM</text>
    <text x="50" y="72" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="bold" fill="#22d3ee" textAnchor="middle">CGC</text>
    
    <circle cx="50" cy="10" r="2" fill="#38bdf8"/>
    <circle cx="50" cy="90" r="2" fill="#38bdf8"/>
    <circle cx="10" cy="50" r="2" fill="#38bdf8"/>
    <circle cx="90" cy="50" r="2" fill="#38bdf8"/>
  </svg>
);

export default function Loader({ size, onFadeComplete }) {
  // Simple size prop, no hooks
  const finalSize = size || 100;
  
  const [fading, setFading] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 2000);
    const removeTimer = setTimeout(() => {
      setVisible(false);
      if (onFadeComplete) onFadeComplete();
    }, 2500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [onFadeComplete]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: '#020617',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        opacity: fading ? 0 : 1,
        transition: 'opacity 0.5s ease-out',
        pointerEvents: fading ? 'none' : 'auto',
      }}
    >
      <div style={{ position: 'relative', width: finalSize, height: finalSize }}>
        {/* Spinning outer ring */}
        <div
          style={{
            position: 'absolute',
            top: -10,
            left: -10,
            width: finalSize + 20,
            height: finalSize + 20,
            animation: 'spin 1s linear infinite',
          }}
        >
          <svg width="100%" height="100%" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="48" fill="none" stroke="#38bdf8" strokeWidth="2" strokeDasharray="30 70" opacity="0.8"/>
          </svg>
        </div>

        {/* Reverse spinning inner ring */}
        <div
          style={{
            position: 'absolute',
            top: -5,
            left: -5,
            width: finalSize + 10,
            height: finalSize + 10,
            animation: 'spinReverse 1.5s linear infinite',
          }}
        >
          <svg width="100%" height="100%" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="48" fill="none" stroke="#818cf8" strokeWidth="2" strokeDasharray="20 80" opacity="0.6"/>
          </svg>
        </div>

        {/* Center Logo */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <LogoSVG size={finalSize} />
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes spinReverse {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
      `}</style>
    </div>
  );
}